<template><div><h2 id="examples" tabindex="-1" class="d-docsite--header-2">Examples <a class="header-anchor d-link d-docsite--link d-link" href="#examples" aria-hidden="true">#</a></h2>
<code-example source-code='&lt;div class=&quot;d-p-100 d-ba d-baw4 d-bar-300 d-bc-default d-bgc-moderate d-d-block&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm&quot;&gt;d-d-block&lt;/dt-stack&gt;
&lt;/div&gt;
&lt;div class=&quot;d-d-contents&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm&quot;&gt;d-d-contents&lt;/dt-stack&gt;
&lt;/div&gt;
&lt;dt-stack direction=&quot;row&quot; gap=&quot;100&quot; class=&quot;d-p-100 d-ba d-baw4 d-bar-300 d-bgc-moderate&quot;&gt;
  &lt;div&gt;
    &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline-block&quot;&gt;d-d-inline-block&lt;/dt-stack&gt;
  &lt;/div&gt;
  &lt;div&gt;
    &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline-block&quot;&gt;d-d-inline-block&lt;/dt-stack&gt;
  &lt;/div&gt;
  &lt;div&gt;
    &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline-block&quot;&gt;d-d-inline-block&lt;/dt-stack&gt;
  &lt;/div&gt;
&lt;/dt-stack&gt;
&lt;dt-stack direction=&quot;row&quot; gap=&quot;100&quot; class=&quot;d-p-100 d-ba d-baw4 d-bar-300 d-bgc-moderate&quot;&gt;
  &lt;div&gt;
    &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-fl1 d-as-stretch d-p-50 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline&quot;&gt;d-d-inline&lt;/dt-stack&gt;
  &lt;/div&gt;
  &lt;div&gt;
    &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-fl1 d-as-stretch d-p-50 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline&quot;&gt;d-d-inline&lt;/dt-stack&gt;
  &lt;/div&gt;
  &lt;div&gt;
    &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-fl1 d-as-stretch d-p-50 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline&quot;&gt;d-d-inline&lt;/dt-stack&gt;
  &lt;/div&gt;
&lt;/dt-stack&gt;'>
<dt-stack data-demo-wrapper gap="200" class="d-w100p">
  <div class="d-p-100 d-ba d-baw4 d-bar-300 d-bc-default d-bgc-moderate d-d-block">
    <dt-stack direction="row" align="center" justify="center" class="d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm">d-d-block</dt-stack>
  </div>
  <div class="d-d-contents">
    <dt-stack direction="row" align="center" justify="center" class="d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm">d-d-contents</dt-stack>
  </div>
  <dt-stack direction="row" gap="100" class="d-p-100 d-ba d-baw4 d-bar-300 d-bgc-moderate">
    <div>
      <dt-stack direction="row" align="center" justify="center" class="d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline-block">d-d-inline-block</dt-stack>
    </div>
    <div>
      <dt-stack direction="row" align="center" justify="center" class="d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline-block">d-d-inline-block</dt-stack>
    </div>
    <div>
      <dt-stack direction="row" align="center" justify="center" class="d-fl1 d-as-stretch d-p-100 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline-block">d-d-inline-block</dt-stack>
    </div>
  </dt-stack>
  <dt-stack direction="row" gap="100" class="d-p-100 d-ba d-baw4 d-bar-300 d-bgc-moderate">
    <div>
      <dt-stack direction="row" align="center" justify="center" class="d-fl1 d-as-stretch d-p-50 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline">d-d-inline</dt-stack>
    </div>
    <div>
      <dt-stack direction="row" align="center" justify="center" class="d-fl1 d-as-stretch d-p-50 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline">d-d-inline</dt-stack>
    </div>
    <div>
      <dt-stack direction="row" align="center" justify="center" class="d-fl1 d-as-stretch d-p-50 d-bgc-moderate-opaque d-bar-200 d-code--sm d-d-inline">d-d-inline</dt-stack>
    </div>
  </dt-stack>
</dt-stack>
</code-example>
<h2 id="flex-display" tabindex="-1" class="d-docsite--header-2">Flex Display <a class="header-anchor d-link d-docsite--link d-link" href="#flex-display" aria-hidden="true">#</a></h2>
<dt-notice kind="warning" title="Use DtStack in favor of Flex CSS Utilities" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
Use the <a href="/components/stack" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">DtStack</a> component for most Flex-based layout implementations. View <a href="/about/whats-new/posts/2025-12-2" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Migrating from Flex CSS Utilities to DtStack</a> for more details.
</dt-notice>
<p class="d-docsite--paragraph">While <code v-pre>d-d-flex</code> and <code v-pre>d-d-inline-flex</code> technically are <code v-pre>display</code> utilities, use the <a href="/components/stack" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">DtStack</a> component instead.</p>
<code-example source-code='&lt;dt-stack
  gap=&quot;200&quot;
  direction=&quot;row&quot;
  class=&quot;d-bgc-moderate-opaque d-bar-400&quot;
&gt;
  &lt;div class=&quot;d-bgc-moderate-opaque d-p-200 d-bar-400&quot;&gt;
    Stack item 1
  &lt;/div&gt;
  &lt;div class=&quot;d-bgc-moderate-opaque d-p-200 d-bar-400&quot;&gt;
    Stack item 2
  &lt;/div&gt;
  &lt;div class=&quot;d-bgc-moderate-opaque d-p-200 d-bar-400&quot;&gt;
    Stack item 3
  &lt;/div&gt;
&lt;/dt-stack&gt;'>
<dt-stack
  gap="200"
  direction="row"
  class="d-bgc-moderate-opaque d-bar-400"
>
  <div class="d-bgc-moderate-opaque d-p-200 d-bar-400">
    Stack item 1
  </div>
  <div class="d-bgc-moderate-opaque d-p-200 d-bar-400">
    Stack item 2
  </div>
  <div class="d-bgc-moderate-opaque d-p-200 d-bar-400">
    Stack item 3
  </div>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<new-utility-class-table :classes="display"></new-utility-class-table></div></template>


<script setup>
  import { inject } from 'vue';
  import { extractUtilityClasses } from '@utilities';

  const utilityClassDocs = inject('utilityClassDocs');
  const display = extractUtilityClasses(utilityClassDocs, 'd-d-');
</script>